import * as React from 'react';
import cx from 'classnames';

import AnonSVG from 'img-src/static/anon.svg';

import Img from 'ha/ui/next/Img';
import { withConfig, ConfigProps } from 'ha/helpers/config';

interface Props {
  avatarURL: string;
  isBordered?: boolean;
  className?: string;
  lg?: boolean;
  md?: boolean;
  sm?: boolean;
  xs?: boolean;
  xsm?: boolean;
  xxs?: boolean;
  online?: boolean;
  offline?: boolean;
  imgClassName?: string;
}

export const UserAvatar: React.SFC<Props & ConfigProps> = ({
  lg,
  md,
  sm,
  xs,
  xsm,
  xxs,
  avatarURL,
  online,
  offline,
  className,
  isBordered,
  imgClassName,
  appConfig,
}) => {
  const imageTimeoutMs =
    appConfig && appConfig.thumb && appConfig.thumb.imageTimeoutMs;
  const avatarSrc = avatarURL || AnonSVG;
  const showOnline = online === true;
  const showOffline =
    offline === true || (offline !== false && online === false);

  return (
    <div
      className={cx('avatar--wrapper', className, {
        avatar__lg: lg,
        avatar__md: md,
        avatar__sm: sm,
        avatar__xsm: xsm,
        avatar__xs: xs,
        avatar__xxs: xxs,
        'avatar--status': showOnline || showOffline,
        'avatar--status--online': showOnline,
        'avatar--status--offline': showOffline,
      })}
      data-test-locator="User Card Avatar"
    >
      <Img
        src={avatarSrc}
        defaultSrc={AnonSVG}
        alt="User avatar"
        className={cx('avatar--img', imgClassName, {
          'border-outline': isBordered,
        })}
        timeoutMs={imageTimeoutMs}
      />
    </div>
  );
};

export default withConfig(UserAvatar);
